import { EPlatformTypes } from '@cian/frontend-newbuilding-call-component';
import * as React from 'react';

import { getPhoneLink } from './getPhoneLink';
import { requestDynamicPhone } from './requestDynamicPhone';
import { useApplicationContext } from '../../utils/applicationContext';

interface IUseDynamicPhoneParams {
  entityId: number;
  phone?: string | null;
  siteBlockId?: number | null;
}

export function useDynamicPhone({ entityId, phone, siteBlockId }: IUseDynamicPhoneParams): () => Promise<void> {
  const { httpApi, logger } = useApplicationContext();

  return React.useCallback(async () => {
    const dynamicPhone = await requestDynamicPhone({
      httpApi,
      logger,
      entityId,
      siteBlockId,
      platformType: EPlatformTypes.WebMobile,
    });

    const telHref = getPhoneLink(dynamicPhone) || getPhoneLink(phone);

    if (!telHref) {
      return;
    }

    window.location.href = `tel:${telHref}`;
  }, [entityId, httpApi, logger, phone, siteBlockId]);
}
